import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
import { useMsal } from "@azure/msal-react";
import {
  Avatar,
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { selectAdminIds } from "../store/UserMaintanence";
function Searchnav() {

  const { instance } = useMsal();

  const loggedInEnterpriseId =
    instance.getActiveAccount()?.idTokenClaims?.enterpriseID || "";
  const adminEnterpriseIds = useSelector(selectAdminIds);
  return (
    <>
      <header className="searchnav">
        <div className="searchnav-container">

          <div className="searchnav-left">
            <img
              src={process.env.PUBLIC_URL +"/images/Home/Acc_GT_Gradient_RGB-new.png"}
              className="acc-logo"
              alt="Accenture logo"
            />
            <span className="title">
              L&TT
            </span>
            <span className="nav-divider" />
            <span className="nav-title">
              Community of Learning
            </span>
          </div>

          <nav className="searchnav-center">
            <NavLink
              to="/home"
              className="nav-link"
              activeClassName="active"
            >
              Home
            </NavLink>
            <NavLink
              to="/dashboard"
              className="nav-link"
              activeClassName="active"
            >
              My Dashboard
            </NavLink>

            <NavLink
              to="/hall-of-fame"
              className="nav-link"
              activeClassName="active"
            >
              Hall of Fame
            </NavLink>
            <a
              href="https://cop.accenture.com/#/global" target="_blank"
              className="nav-link"
              activeClassName="active"
            >
              Community of Practices
            </a>
            {adminEnterpriseIds?.includes(loggedInEnterpriseId) && (
              <div className="admin-menu">
                <span className="nav-link admin-title">
                  Admin <KeyboardArrowDown style={{ fontSize: 18, marginLeft: 4 }} />
                </span>

                <div className="admin-dropdown">
                  <NavLink to="/analytics" className="dropdown-link">
                    Analytics
                  </NavLink>
                  <NavLink to="/reviews" className="dropdown-link">
                    Feedbacks
                  </NavLink>
                  <NavLink to="/metrics" className="dropdown-link">
                    Metrics
                  </NavLink>
                  <NavLink to="/user-maintenance" className="dropdown-link">
                    User Maintenance
                  </NavLink>
                </div>
              </div>
            )}
          </nav>

          <div className="searchnav-right">
            <WelcomeName />
            {/* <img
              src={process.env.PUBLIC_URL +"/images/Avatar.png"}
              className="user-img"
              alt="user avatar"
            /> */}
            <Avatar
              sx={{ width: 32, height: 32}}
            />
          </div>

        </div>
      </header>
    </>
  );
}

export default Searchnav;
